<template>
  <div :style="'overflow: auto; height: calc(100vh - 310px);'" >
<!--      <v-btn @click="debouncedReloadTrips()" depressed block large :color="$vuetify.theme.dark ? 'black' : '#eee'">-->
<!--        <v-icon left>fas fa-redo</v-icon>-->
<!--        {{ t({s: 'sidebar.reload', component: 'Map'}) }}-->
<!--      </v-btn>-->
    <v-container v-if="!loading && weekdays.length === 0">
      <v-alert
        outlined
        type="info">
        {{ t({s: 'sidebar.error.noTrips', component: 'Map'}) }}
      </v-alert>
    </v-container>
    <v-spacer></v-spacer>
    <div v-for="(grouped, key) in weekdays" :key="key">
      <Header
          :trips="grouped"
          :loading="false"
          v-on:click.native="() => show(grouped.trips)" />

      <v-divider />

      <Trip v-for="(trip, key) in grouped.trips"
            :key="key"
            :trip="trip"
            :loading="requested.includes(trip.id) && !loaded.includes(trip.id)"
            :active="loaded.includes(trip.id)"
            :error="errors.includes(trip.id)"
            v-on:click.native="() => show([trip])"/>
    </div>

    <v-card v-intersect="getTrips" flat>
      <loader :yes="loading"/>
    </v-card>
    <v-btn v-if="page !== totalPages && !loading" @click="getTrips()" depressed block large color="#eee">
        <v-icon left>fas fa-redo</v-icon>
        {{ t({s: 'sidebar.loadMore', component: 'Map'}) }}
    </v-btn>
  </div>
</template>

<script lang="js">
import Loader from '@/components/Global/Loader'
import Trip from '@/components/Map/TripsTab/Trip'
import Header from '@/components/Map/TripsTab/Header'
import { colors } from '@/store/trips.js'
import { apiGetEntityTripsPaginated, apiGetTripDetails } from '@/api'

export default {
  name: 'TripsPane',
  components: { Loader, Trip, Header },
  props: {
    entity: {
      required: true
    }
  },
  data: () => ({
    loading: false,
    weekdays: [],
    requested: [],
    loaded: [],
    errors: [],
    page: 0,
    totalPages: null,
    timeLastUpdated: Date.now()
  }),
  mounted () {
    this.getTrips()
  },
  methods: {
    getTrips () {
      if (this.loading || !this.entity || this.totalPages === 0 || this.page === this.totalPages) {
        return
      }

      if (this.entity?.trips) {
        this.entity.trips.forEach(trip => this.addTrip(trip))
        this.page = 1
        this.totalPages = 1
        return
      }

      this.loading = true
      apiGetEntityTripsPaginated(this.entity.id, this.page + 1)
        .then(result => {
          const { data } = result
          this.loading = false
          this.page = data.pagination.current_page
          this.totalPages = data.pagination.total_pages
          data.data.forEach(trip => this.addTrip(trip))
        })
    },
    addTrip (trip) {
      if (this.weekdays.some(day => day.trips.some(dt => dt.id === trip.id))) return

      let secondsBetweenStartStop = this.$moment(trip.trip_ended_at).diff(trip.trip_started_at, 'seconds')
      if (!(trip.duration > secondsBetweenStartStop)) {
        secondsBetweenStartStop = trip.duration
      }

      const number = this.$moment(trip.trip_started_at).startOf('day').format('X')
      const index = this.weekdays.findIndex(d => d.id === number)

      if (index === -1) {
        this.weekdays.push({
          id: number,
          day: this.$moment(trip.trip_started_at).format('dddd, LL'),
          totals: {
            distance: trip.distance,
            duration: secondsBetweenStartStop
          },
          trips: [trip]
        })

        return true
      }

      this.weekdays[index] = {
        ...this.weekdays[index],
        totals: {
          distance: this.weekdays[index].totals.distance + trip.distance,
          duration: this.weekdays[index].totals.duration + secondsBetweenStartStop
        },
        trips: [
          ...this.weekdays[index].trips,
          trip
        ]
      }
    },
    getColor (index) {
      if (index < colors.length) {
        return colors[index]
      }
      return colors[Math.floor(Math.random() * ((colors.length - 1) - 1)) + 1]
    },
    async show (trips) {
      if (trips.length === 1 && this.loaded.length === 1 && this.loaded[0] === trips[0].id) {
        this.$store.commit('Trips/setTrips', { trips: [] })
        this.loaded = []
        this.requested = []
      } else {
        this.loaded = []
        this.requested = trips.map(t => t.id)
        const lines = trips.map(async (trip, index) => {
          const path = []
          const { data } = await apiGetTripDetails(trip.id)
          const body = data.data

          body.waypoints.forEach(w => {
            path.push({
              lat: w.position.latitude,
              lng: w.position.longitude
            })
          })

          return {
            path,
            id: trip.id,
            geodesic: true,
            strokeColor: this.getColor(index),
            strokeOpacity: 1,
            strokeWeight: 5,
            markers: [{
              icon: '/img/markers/start.png',
              position: path[0]
            }, {
              icon: '/img/markers/end.png',
              position: path[path.length - 1]
            }]
          }
        })

        Promise.all(lines)
          .then(trips => {
            this.$store.commit('Trips/setTrips', { trips })
            this.loaded = trips.map(t => t.id)
          })
          .catch(e => console.error(e))
      }
    },
    reloadTrips () {
      this.$store.commit('Map/resetShowTrips')
      this.weekdays = []
      this.page = 0
      this.totalPages = null
      this.getTrips()
    },
    debouncedReloadTrips () {
      const isMinuteAgo = (Date.now() - 60000) > this.timeLastUpdated

      if (isMinuteAgo) {
        this.reloadTrips()
        this.timeLastUpdated = Date.now()
      }
    }
  },
  watch: {
    entity (entity, old) {
      if (entity.id === old?.id) {
        return
      }
      this.reloadTrips()
    },
    loaded (trips) {
      this.$emit('loaded', trips)
    }
  }
}
</script>

<style scoped>
Header:hover, Trip:hover {
  cursor: pointer;
}

#unitSidebar.scrolled {
  height: 100%;
}

#unitSidebar .getTrips {
  cursor: pointer;
}

#unitSidebar.scrolled #scroll-target {
  max-height: calc(100vh - (64px + 90px + 48px));
}

#unitSidebar.scrolled .googleStatic {
  height: 90px !important;
  transition: ease all 0.3s;
}

#unitSidebar.scrolled .v-toolbar__content {
  height: 90px !important;
  transition: ease all 0.3s;
}

#scroll-target {
  max-height: calc(100vh - (64px + 200px + 48px));
}

#unitSidebar .v-toolbar__content,
#unitSidebar .googleStatic {
  height: 200px !important;
  transition: ease all 0.3s;
}

#unitSidebar .heading--daily {
  color: rgb(21, 27, 30);
  background-color: rgba(235, 235, 235, .15);
  padding: 1em 0 !important;
}

#unitSidebar .heading--daily .v-card__title {
  border-bottom: thin solid rgba(235, 235, 235, .75);
  padding: 1em 1.2em !important;
}

#unitSidebar .heading--daily .totals,
#unitSidebar .heading--daily .v-tooltip {
  font-weight: 500 !important;
  color: rgb(201, 114, 0) !important;
}
</style>
